import TutorialInit from './tutorialInit'
import TutorialUnlockBenefits from './tutorialUnlockBenefits'
import TutorialUnlockClubs from './tutorialUnlockClubs'
import TutorialUnlockDailyTasks from './tutorialUnlockDailyTasks'
import TutorialUnlockDiscipline1 from './tutorialUnlockDiscipline1'
import TutorialUnlockDiscipline2 from './tutorialUnlockDiscipline2'
import TutorialUnlockDiscipline3 from './tutorialUnlockDiscipline3'
import TutorialUnlockFirstClubJoin from './tutorialUnlockFirstClubJoin'
import TutorialUnlockMapItems from './tutorialUnlockMapItems'
import TutorialUnlockPersonalCoach from './tutorialUnlockPersonalCoach'
import TutorialUnlockResearch from './tutorialUnlockResearch'
import TutorialUnlockStarOfTheDay from './tutorialUnlockStarOfTheDay'
import TutorialUnlockSuperCompetition from './tutorialUnlockSuperCompetition'
import TutorialUnlockSpecialTournamentsIbu from './tutorialUnlockSpecialTournamentsIbu'
import TutorialUnlockTournaments from './tutorialUnlockTournaments'
import TutorialUnlockGallery from './tutorialUnlockGallery'

export const tutorialClasses = {
  TutorialInit,
  TutorialUnlockDiscipline1,
  TutorialUnlockDiscipline2,
  TutorialUnlockDiscipline3,
  TutorialUnlockMapItems,
  TutorialUnlockDailyTasks,
  TutorialUnlockPersonalCoach,
  TutorialUnlockSuperCompetition,
  TutorialUnlockResearch,
  TutorialUnlockBenefits,
  TutorialUnlockStarOfTheDay,
  TutorialUnlockClubs,
  TutorialUnlockFirstClubJoin,
  TutorialUnlockSpecialTournamentsIbu,
  TutorialUnlockTournaments,
  TutorialUnlockGallery,
}
